import { Expander } from '@cian/ui-kit';

import { type FC } from 'react';

import { type QuickLinksProps } from '../../types';
import { QuickLinkItem } from '../QuickLinkItem';

import styles from './QuickLinksInlineList.css';

export const QuickLinksInlineList: FC<QuickLinksProps> = ({ quickLinks, trackQuickLinkClick }) => {
  return (
    <Expander.List inline collapseButtonText="Свернуть" expandButtonText="Ещё" gap={16} visibleItemsCount={3}>
      {quickLinks.map(link => (
        <div className={styles['link-item']} key={link.id}>
          <QuickLinkItem
            short
            offersCount={link.offersCount}
            paddingLink={4}
            title={link.title}
            track={(): void => trackQuickLinkClick(link)}
            url={link.url}
          />
        </div>
      ))}
    </Expander.List>
  );
};
